export const DEVICEID_LOADER_START = "@@deviceId/startLoading";
export const DEVICEID_LOADER_STOP = "@@deviceId/stopLoading";
export const LOADER_START = "@@loadStart/startLoadingtwo";
export const LOADER_STOP = "@@loadStop/stopLoadingtwo";
export const FETCH_DEVICES_REQUEST = "@@deviceId/FETCH_DEVICES_REQUEST";
export const FETCH_DEVICES_SUCCESS = "@@deviceId/FETCH_DEVICES_SUCCESS";
export const FETCH_DEVICES_FAILURE = "@@deviceId/FETCH_DEVICES_FAILURE";
export const UPDATE_DEVICE_STATUS_REQUEST =
  "@@deviceId/UPDATE_DEVICE_STATUS_REQUEST";
export const UPDATE_DEVICE_STATUS_SUCCESS =
  "@@deviceId/UPDATE_DEVICE_STATUS_SUCCESS";
export const UPDATE_DEVICE_STATUS_FAILURE =
  "@@deviceId/UPDATE_DEVICE_STATUS_FAILURE";
export const ASSIGN_PROJECT_TO_DEVICEID =
  "@@deviceId/ASSIGN_PROJECT_TO_DEVICEID";
export const COMM_CHECK_REQUEST = "@@deviceId/COMM_CHECK_REQUEST";
export const COMM_CHECK_SUCCESS = "@@deviceId/COMM_CHECK_SUCCESS";
export const COMM_CHECK_FAILURE = "@@deviceId/COMM_CHECK_FAILURE";
export const SET_TIME_REQUEST = "COMMAND/SET_TIME_REQUEST";
export const GET_TIME_REQUEST = "COMMAND/GET_TIME_REQUEST";
export const ERASE_LOGS_REQUEST = "COMMAND/ERASE_LOGS_REQUEST";
export const NUM_OF_LOGS_REQUEST = "COMMAND/NUM_OF_LOGS_REQUEST";
export const WELD_PARAMETER_DOWNLOAD_REQUEST =
  "COMMAND/WELD_PARAMETER_DOWNLOAD_REQUEST";
export const LOCATION_REQUEST = "COMMAND/LOCATION_REQUEST";
export const PASSWORD_PROTECTION_REQUEST =
  "COMMAND/PASSWORD_PROTECTION_REQUEST";

// Get device by ID types
export const GET_DEVICE_BY_ID_REQUEST = "@@deviceId/GET_DEVICE_BY_ID_REQUEST";
export const GET_DEVICE_BY_ID_SUCCESS = "@@deviceId/GET_DEVICE_BY_ID_SUCCESS";
export const GET_DEVICE_BY_ID_FAILURE = "@@deviceId/GET_DEVICE_BY_ID_FAILURE";

// Generic success/failure types
export const COMMAND_SUCCESS = "COMMAND/SUCCESS";
export const COMMAND_FAILURE = "COMMAND/FAILURE";

// Clear command responses
export const CLEAR_COMMAND_RESPONSE = "COMMAND/CLEAR_RESPONSE";
